<div class="grid grid-cols-12 gap-4">
  <div class="col-fixed icon-not-found-component"></div>
  <div class="col font-semibold">{{featureName}} Data Not Found</div>
</div>
